// extracted by mini-css-extract-plugin
module.exports = {"customRows":"SwitchCompany_customRows__38si-"};